export default {
  button: {
    add: 'Añadir',
    insert: 'Insertar',
    update: 'Actualizar',
    cancel: 'Cancelar',
    duplicate: 'Duplicar',
    rectify: 'Rectificar',
    back: 'Volver',
    delete: 'Eliminar',
    search: 'Buscar',
    save: 'Guardar',
    continue: 'Continuar',
    send: 'Enviar',
    issue: 'Emitir',
    export: 'Exportar {0}',
    accept: 'Aceptar',
    close: 'Cerrar',
    watchAll: 'Ver todos',
    undo: 'Deshacer',
    newElement: 'Nuevo elemento',
    create: 'Crear',
    watchConditions: 'Ver condiciones',
    reject: 'Rechazar',
    unreject: 'Des-rechazar',
    view: 'Detalle de la factura',
    edit: 'Editar',
    ok: 'Ok',
    cancelInvoice: 'Anular',
    acceptCancel: 'Aceptar anulación',
    rejectCancel: 'Rechazar anulación'
  },
  sharedInfo: {
    requiredFields: '(*) Campos obligatorios'
  },
  pagination: {
    showing: 'Mostrando'
  },
  file: {
    select: 'Seleccionar archivo',
    noneSelected: 'Ningún archivo seleccionado'
  },
  spinner: {
    loading: 'Cargando operativa...',
    processing: 'Realizando operativa'
  },
  error: 'Se ha producido un error'
}
